import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from '@apas-one/app.component';
import { appConfig } from '@apas-one/app.config';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
